import { NgModule } from '@angular/core';
import { FiPasswordValidationProgressComponent } from './password-validation-progress.component';
import { FiPasswordValidationProgressHelperService } from './password-validation-progress-helper.service';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '../app-text';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, MatIconModule],
    declarations: [FiPasswordValidationProgressComponent],
    providers: [FiPasswordValidationProgressHelperService],
    exports: [FiPasswordValidationProgressComponent],
})
export class FiPasswordValidationProgressModule {}
